import React from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Form, FormInput, FormSelect, Button } from "shards-react";
import * as XLSX from "xlsx";
import ConversionDataService from "../../services/conversions.service";
import { FcPlus, FcList } from "react-icons/fc";
import { ToastContainer, toast } from "react-toastify";
import { actions as AppActions } from "../../_stores/app.store";

class CreateConversions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      RetailerId: "",
      PROD_CODE: "",
      PROD_NAME: "",
      UOM: "",
      Conversion: "",
      isConversionFound: "",
      isBulkUpload: true,
      uploadReady: false,
      excelRows: [],
    };

    this.onFieldValueChange = this.onFieldValueChange.bind(this);
    this.toggleBulkUpload = this.toggleBulkUpload.bind(this);
    this.onFileChanged = this.onFileChanged.bind(this);
    this.handleAddConversionForm = this.handleAddConversionForm.bind(this);
    this.handleUpdateConversionForm = this.handleUpdateConversionForm.bind(this);
    this.handleBulkUpload = this.handleBulkUpload.bind(this);
  }

  componentDidMount() {
    if (this.props.conversionId) {
      this.retrieveConversionDetails();
      this.setState({ isBulkUpload: false });
    }
  }

  retrieveConversionDetails() {
    ConversionDataService.get(this.props.conversionId).then((response) => {
      var conversionDetails = response.data.data[0];

      this.setState({
        RetailerId: conversionDetails.RetailerId,
        PROD_CODE: conversionDetails.PROD_CODE,
        PROD_NAME: conversionDetails.PROD_NAME,
        UOM: conversionDetails.UOM,
        Conversion: conversionDetails.Conversion,
        isConversionFound: conversionDetails.isConversionFound
      });
    });
  }

  onFieldValueChange(e) {
    this.setState({
      [e.target.id]: e.target.value,
    });
  }

  toggleBulkUpload() {
    this.setState({ isBulkUpload: !this.state.isBulkUpload });
  }

  notify(type, message) {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type: type,
    });
  }

  handleAddConversionForm() {
    const { RetailerId, PROD_CODE, PROD_NAME, UOM, Conversion } = this.state;
    
    var data = {
      RetailerId, 
      PROD_CODE, 
      PROD_NAME, 
      UOM, 
      Conversion, 
      isConversionFound: 1
    };
    
    AppActions.setLoading(true);
    ConversionDataService.create(data).then((response) => {
      AppActions.setLoading(false);
      if (response.data.success) {
        if (response.data.message.insertId) {
          var notify_message = {
            type: "success",
            message: "Conversion has been created successfully.",
          };
          this.props.redirectToConversionDetails("/conversion/view", notify_message);
        } else {
          var notify_message = {
            type: "error",
            message: "Server error in creating conversion.",
          };
          this.notify(notify_message.type, notify_message.message);
        }
      } else {
        var notify_message = {
          type: "error",
          message: "Failed to create conversion.",
        };
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  handleUpdateConversionForm() {
    const { RetailerId, PROD_CODE, PROD_NAME, UOM, Conversion } = this.state;
    
    var data = {
      RetailerId, 
      PROD_CODE, 
      PROD_NAME, 
      UOM, 
      Conversion, 
      isConversionFound: 1
    };

    AppActions.setLoading(true);
    ConversionDataService.update(this.props.conversionId, data).then((response) => {
      AppActions.setLoading(false);
      if (response.data.success) {
        if (response.data.message.affectedRows) {
          var notify_message = {
            type: "success",
            message: "Conversion has been updated successfully.",
          };
          this.props.redirectToConversionDetails("/conversion/view", notify_message);
        } else {
          var notify_message = {
            type: "error",
            message: "Server error in updating conversion.",
          };
          this.notify(notify_message.type, notify_message.message);
        }
      } else {
        var notify_message = {
          type: "error",
          message: "Failed to update conversion.",
        };
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  onFileChanged(evt) {
    AppActions.setLoading(true);
    const { target } = evt;
    let file = null;

    if (target.files && target.files.length) {
      file = target.files[0];
    }
    this.readFileData(file);
  }

  async readFileData(file) {
    const reader = new FileReader();
    if (reader.readAsBinaryString) {
      reader.onload = async (e) => {
        this.extractExcelData(reader.result);
      };
      reader.readAsBinaryString(file);
    }
  }

  extractExcelData(data) {
    const workbook = XLSX.read(data, {
      type: "binary",
    });
    const sheet01 = workbook.Sheets[workbook.SheetNames[0]];
    const sheetdata = XLSX.utils.sheet_to_json(sheet01, {
      header: 1,
    });
    sheetdata.splice(0, 1);
    if (sheetdata.length && sheetdata[0].length)
      this.setState({
        excelRows: sheetdata,
        uploadReady: true,
      });
    else this.notify("error", "No data found in the sheet");
    AppActions.setLoading(false);
  }

  handleBulkUpload() {
    const { excelRows } = this.state;
    const bulkData = excelRows.map((row) => ({
      id: row[0],
      RetailerId: row[1],
      PROD_CODE: row[2],
      PROD_NAME: row[3],
      UOM: row[5],
      Conversion: row[6],
      isConversionFound: row[7],
    }));

    AppActions.setLoading(true);
    ConversionDataService.bulkCreate({ bulkData }).then((response) => {
      AppActions.setLoading(false);
     
      if (response.data.success) {
        if (response.data.message.affectedRows) {
          var notify_message = {
            type: "success",
            message: "Bulk Conversions created successfully.",
          };
          this.props.redirectToConversionDetails("/conversion/view", notify_message);
        } else {
          var notify_message = {
            type: "error",
            message: "Server error in creating Bulk Conversion.",
          };
          this.notify(notify_message.type, notify_message.message);
        }
      } else {
        var notify_message = {
          type: "error",
          message: response.data.message,
        };
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  render() {
    const { RetailerId, PROD_CODE, PROD_NAME, UOM, Conversion, isConversionFound, isBulkUpload, uploadReady } = this.state;
    const { conversionId } = this.props;

    return (
      <div>
        <Card small className="mb-4">
          <CardHeader className="border-bottom d-flex">
            <h6 className="m-0">
              {conversionId ? "Update Single" : !isBulkUpload ? "Create Single" : "Create Bulk"} Conversion
            </h6>
            {!conversionId ? (
              !isBulkUpload ? (
                <Button className="ml-3" variant="primary" onClick={this.toggleBulkUpload}>
                  <FcPlus /> Bulk Import
                </Button>
              ) : (
                <Button className="ml-3" variant="primary" onClick={this.toggleBulkUpload}>
                  <FcPlus /> Single Create
                </Button>
              )
            ) : (
              <></>
            )}
            <Link className="btn btn-primary ml-4" to={"/conversion/view"}>
              <FcList /> View All
            </Link>
          </CardHeader>
          <ListGroup flush>
            <ListGroupItem className="">
              {!isBulkUpload ? (
                <Form>
                  <Row form>
                    <Col md="12" className="form-group">
                      <Row className="form-group-row">
                        <Col className="form-label" md="3">
                          <label htmlFor="RetailerId">Retailer ID</label>
                        </Col>
                        <Col className="form-field" md="9">
                          <FormInput
                            id="RetailerId"
                            placeholder="Retailer ID"
                            value={RetailerId}
                            onChange={this.onFieldValueChange}
                            disabled={conversionId}
                          />
                        </Col>
                      </Row>

                      <Row className="form-group-row">
                        <Col className="form-label" md="3">
                          <label htmlFor="PROD_CODE">Product Code</label>
                        </Col>
                        <Col className="form-field" md="9">
                          <FormInput
                            id="PROD_CODE"
                            placeholder="Product Code"
                            value={PROD_CODE}
                            onChange={this.onFieldValueChange}
                            disabled={conversionId}
                          />
                        </Col>
                      </Row>

                      <Row className="form-group-row">
                        <Col className="form-label" md="3">
                          <label htmlFor="PROD_NAME">Product Name</label>
                        </Col>
                        <Col className="form-field" md="9">
                          <FormInput
                            id="PROD_NAME"
                            placeholder="Product Name"
                            value={PROD_NAME}
                            onChange={this.onFieldValueChange}
                            disabled={conversionId}
                          />
                        </Col>
                      </Row>

                      <Row className="form-group-row">
                        <Col className="form-label" md="3">
                          <label htmlFor="UOM">UOM</label>
                        </Col>
                        <Col className="form-field" md="9">
                          <FormInput
                            id="UOM"
                            placeholder="UOM"
                            value={UOM}
                            onChange={this.onFieldValueChange}
                            disabled={conversionId}
                          />
                        </Col>
                      </Row>

                      <Row className="form-group-row">
                        <Col className="form-label" md="3">
                          <label htmlFor="Conversion">Conversion</label>
                        </Col>
                        <Col className="form-field" md="9">
                          <FormInput
                            id="Conversion"
                            placeholder="Conversion"
                            value={Conversion}
                            onChange={this.onFieldValueChange}
                          />
                        </Col>
                      </Row>

                      <Row className="form-group-row">
                        <Col className="form-button" md="4">
                          {conversionId ? (
                            <Button
                              className="btn btn-primary float-left mr-3"
                              theme="accent"
                              onClick={this.handleUpdateConversionForm}
                            >
                              <FcPlus /> Update
                            </Button>
                          ) : (
                            <Button variant="primary" className="float-left mr-3" onClick={this.handleAddConversionForm}>
                              <FcPlus /> Create
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <Form>
                  <Row form>
                    <Col md="12" className="form-group">
                      <Row className="form-group-row">
                        <Col className="form-label" md="4">
                          <label htmlFor="">Select Excel File</label>
                        </Col>
                        <Col className="form-field" md="8">
                          <div className="file-ctrl-wrap">
                            <input
                              type="file"
                              className="file-input"
                              id="file"
                              name="file"
                              placeholder="Browse excel file to upload"
                              onChange={this.onFileChanged}
                            />
                          </div>
                        </Col>
                      </Row>
                      {uploadReady ? (
                        <Row className="form-group-row">
                          <Col className="form-button" md="4">
                            <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleBulkUpload}>
                              <FcPlus /> Upload Conversion Data
                            </Button>
                          </Col>
                        </Row>
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                </Form>
              )}
            </ListGroupItem>
          </ListGroup>
        </Card>
        <ToastContainer />
      </div>
    );
  }
}

export default CreateConversions;
